var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.modalConfig.title,
        visible: _vm.modalConfig.visible,
        width: _vm.modalConfig.width || "1000px",
        destroyOnClose: true,
        footer: null,
        centered: "",
        maskClosable: false,
      },
      on: { cancel: _vm.close },
    },
    [
      _c(
        "el-scrollbar",
        {
          class:
            _vm.modalConfig.bottomPadding === false
              ? "paddingbottom20"
              : "dialog-style",
          style: { height: _vm.modalConfig.height || "60vh" },
          attrs: {
            "wrap-class": "modal-scrollbar",
            native: false,
            "view-class": "modal-container",
            noresize: false,
            tag: "div",
          },
        },
        [
          _vm._t("default"),
          _vm.modalConfig.showFooter
            ? _c("div", { staticClass: "dialog-footer" }, [
                _c(
                  "div",
                  [
                    _vm.modalConfig.buttons.sure
                      ? _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-check", type: "primary" },
                            on: { click: _vm.onOk },
                          },
                          [_vm._v("确定")]
                        )
                      : _vm.modalConfig.buttons.close
                      ? _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-close", type: "danger" },
                            on: { click: _vm.close },
                          },
                          [_vm._v("关闭")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }